
import { createSelector } from "@reduxjs/toolkit";
export const whatYouNeed = state => state.dialogPolicyPointReducer.whatYouNeed;
export const redeemPoints = state => state.dialogPolicyPointReducer.redeemPoints;
export const missions = state => state.dialogPolicyPointReducer.missions;
export const missionPoints = state => state.dialogPolicyPointReducer.missionPoints;
export const missionsLoaded = state => state.dialogPolicyPointReducer.missionsLoaded;
export const missionsLoading = state => state.dialogPolicyPointReducer.missionsLoading;
